// Core application constants
export const MOCK_USER_ID = "circular_analyst@example.com";
export const LOCAL_STORAGE_KEY = "circularAssetsV6";

export const R_STRATEGIES = {
    R7: { name: 'Re-use / Repair', desc: 'Re-use the product, or repair/maintain it.', baseCostFactor: 0.1, baseValueFactor: 0.95, color: 'bg-green-500' },
    R6: { name: 'Remanufacture / Refurbish', desc: 'Bring product to as good as new condition.', baseCostFactor: 0.3, baseValueFactor: 0.85, color: 'bg-indigo-500' },
    R5: { name: 'Repurpose', desc: 'Use product in a different function.', baseCostFactor: 0.4, baseValueFactor: 0.7, color: 'bg-yellow-500' },
    R4: { name: 'Recycle', desc: 'Process materials for new products.', baseCostFactor: 0.6, baseValueFactor: 0.5, color: 'bg-red-500' }
};


export const PAGE_SIZE = 12;
